import { render, staticRenderFns } from "./select-enterpriseType.vue?vue&type=template&id=08aa55ba&scoped=true"
import script from "./select-enterpriseType.vue?vue&type=script&lang=js"
export * from "./select-enterpriseType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aa55ba",
  null
  
)

export default component.exports